import * as TYPES from './mutationTypes'

export default {
  //区块链列表
  [TYPES.GET_BLOCK_CHAIN](state, payload) {
    const { limit, offset, total } = payload.result
    Object.assign(state, {
      chain_list: payload.result.items,
      chain_paging: { limit, offset, total }
    })
  },
  //合约管理
  [TYPES.GET_BLOCK_CONTRACT](state, payload) {
    const { limit, offset, total } = payload.result
    Object.assign(state, {
      chain_contract_list: payload.result.items,
      chain_contract_paging: { limit, offset, total }
    })
  },
  //上链管理
  [TYPES.GET_UPPER_CHAIN](state, payload) {
    const { limit, offset, total } = payload.result
    Object.assign(state, {
      upper_chain_list: payload.result.items,
      upper_chain_paging: { limit, offset, total }
    })
  },
  //组织管理
  [TYPES.GET_CHAIN_ORG](state, payload) {
    const { limit, offset, total } = payload.result
    Object.assign(state, {
      chain_org_list: payload.result.items,
      chain_org_paging: { limit, offset, total }
    })
  },
  //节点管理
  [TYPES.GET_CHAIN_NODE](state, payload) {
    const { limit, offset, total } = payload.result
    Object.assign(state, {
      chain_node_list: payload.result.items,
      chain_node_paging: { limit, offset, total }
    })
  },

  //扩容节点列表
  [TYPES.GET_OFFCHAIN_NODE](state, payload) {
    const { limit, offset, total } = payload.result
    Object.assign(state, {
      chain_off_chain_node_list: payload.result.items,
      chain_off_chain_node_paging: { limit, offset, total }
    })
  },

  //扩容通道列表
  [TYPES.GET_OFFCHAIN_CHAN_LIST](state, payload) {
    const { limit, offset, total } = payload.result
    Object.assign(state, {
      chain_off_chain_chan_list: payload.result.items,
      chain_off_chain_chan_paging: { limit, offset, total }
    })
  },

  //用户管理
  [TYPES.GET_CHAIN_USER](state, payload) {
    const { limit, offset, total } = payload.result
    payload.result.list.map(item => {
      item.isChecked = false
    })
    Object.assign(state, {
      chain_user_list: payload.result.list,
      chain_user_paging: { limit: (limit || payload.params.limit), offset: (offset || payload.params.offset), total }
    })
  },

  //检索密文
  [TYPES.GET_ACTIVE_CIPHERTEXTID](state, payload) {
    const { limit, offset, total } = payload.result
    Object.assign(state, {
      chain_user_list: payload.result.list,
      chain_user_paging: { limit, offset, total }
    })
  },

  //投票管理
  [TYPES.GET_CHAIN_VOTE](state, payload) {
    const { limit, offset, total } = payload.result
    Object.assign(state, {
      chain_vote_list: payload.result.items,
      chain_vote_paging: { limit, offset, total }
    })
  },
  [TYPES.UPDATE_ACTIVE_TAB](state, payload) {
    state.activeTab = payload
  },
  //归档查询
  [TYPES.GET_ARCHIVING_DETAIL](state, payload) {
    state.archiving_info = payload
  }
}
